import { DatePipe } from "@angular/common";

export class ExportHeaderConstants { // NOSONAR

    ALARM_ID_E01: string = 'E01';
    ALARM_ID_E02: string = 'E02';
    ALARM_ID_E03: string = 'E03';
    ALARM_ID_E06: string = 'E06';
    ALARM_ID_E07: string = 'E07';
    ALARM_ID_E09: string = 'E09';
    ALARM_ID_E10: string = 'E10';
    ALARM_ID_E11: string = 'E11';
    ALARM_ID_E12: string = 'E12';
    ALARM_ID_E13: string = 'E13';
    ALARM_ID_E14: string = 'E14';
    ALARM_ID_E16: string = 'E16';
    ALARM_ID_E17: string = 'E17';
    ALARM_ID_E18: string = 'E18';
    ALARM_ID_E19: string = 'E19';
    ALARM_ID_E21: string = 'E21';
    ALARM_ID_E23: string = 'E23';
    ALARM_ID_E24: string = 'E24';
    ALARM_ID_E25: string = 'E25';
    ALARM_ID_E26: string = 'E26';
    ALARM_ID_E27: string = 'E27';
    ALARM_ID_F01: string = 'F01';
    ALARM_ID_F02: string = 'F02';
    ALARM_ID_F04: string = 'F04';
    ALARM_ID_F05: string = 'F05';
    ALARM_ID_F06: string = 'F06';
    ALARM_ID_F09: string = 'F09';
    ALARM_ID_F11: string = 'F11';
    ALARM_ID_G01: string = 'G01';
    ALARM_ID_G02: string = 'G02';
    ALARM_ID_G06: string = 'G06';
    ALARM_ID_G07: string = 'G07';
    ALARM_ID_H04: string = 'H04';
    ALARM_ID_H05: string = 'H05';
    ALARM_ID_H06: string = 'H06';
    ALARM_ID_H07: string = 'H07';
    ALARM_ID_H09: string = 'H09';
    ALARM_ID_H12: string = 'H12';
    ALARM_ID_H13: string = 'H13';
    ALARM_ID_H14: string = 'H14';
    ALARM_ID_H15: string = 'H15';
    ALARM_ID_H17: string = 'H17';
    ALARM_ID_H20: string = 'H20';
    ALARM_ID_H21: string = 'H21';
    ALARM_ID_H28: string = 'H28';
    ALARM_ID_H29: string = 'H29';
    ALARM_ID_H30: string = 'H30';
    pipe: any;

    constructor() {
        this.pipe = new DatePipe('en-US');
    }

    public getExportHeaders(alarmId: string) { // NOSONAR
        console.info('Input AlarmId in getExportHeader is: ' + alarmId);
        if (alarmId == this.ALARM_ID_E01) { // NOSONAR
            return this.getE01ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E02) { // NOSONAR
            return this.getE02ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E03) { // NOSONAR
            return this.getE03ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E06) { // NOSONAR
            return this.getE06ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E07) { // NOSONAR
            return this.getE07ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E09) { // NOSONAR
            return this.getE09ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E10) { // NOSONAR
            return this.getE10ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E11) { // NOSONAR
            return this.getE11ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E12) { // NOSONAR
            return this.getE12ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E13) { // NOSONAR
            return this.getE13ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E14) { // NOSONAR
            return this.getE14ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E16) { // NOSONAR
            return this.getE16ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E17) { // NOSONAR
            return this.getE17ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E18) { // NOSONAR
            return this.getE18ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E19) { // NOSONAR
            return this.getE19ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E21) { // NOSONAR
            return this.getE21ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E23) { // NOSONAR
            return this.getE23ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E24) { // NOSONAR
            return this.getE24ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E25) { // NOSONAR
            return this.getE25ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E26) { // NOSONAR
            return this.getE26ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_E27) { // NOSONAR
            return this.getE27ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_F01) { // NOSONAR
            return this.getF01ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_F02) { // NOSONAR
            return this.getF02ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_F04) { // NOSONAR
            return this.getF04ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_F05) { // NOSONAR
            return this.getF05ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_F06) { // NOSONAR
            return this.getF06ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_F09) { // NOSONAR
            return this.getF09ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_G01) { // NOSONAR
            return this.getG01ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_G02) { // NOSONAR
            return this.getG02ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_G06) { // NOSONAR
            return this.getG06ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_G07) { // NOSONAR
            return this.getG07ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H04) { // NOSONAR
            return this.getH04ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H05) { // NOSONAR
            return this.getH05ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H06) { // NOSONAR
            return this.getH06ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H07) { // NOSONAR
            return this.getH07ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H09) { // NOSONAR
            return this.getH09ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H12) { // NOSONAR
            return this.getH12ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H13) { // NOSONAR
            return this.getH13ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H14) { // NOSONAR
            return this.getH14ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H15) { // NOSONAR
            return this.getH15ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H17) { // NOSONAR
            return this.getH17ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H20) { // NOSONAR
            return this.getH20ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H21) { // NOSONAR
            return this.getH21ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H28) { // NOSONAR
            return this.getH28ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H29) { // NOSONAR
            return this.getH29ExportHeader();
        }
        else if (alarmId == this.ALARM_ID_H30) { // NOSONAR
            return this.getH30ExportHeader();
        }
        else {
            return this.getE01ExportHeader();
        }
    }

    public getExportData(rowData: any, alarmId: string, alarm: string) { // NOSONAR
        console.info('Input AlarmId in getExportHeader is: ' + alarmId);
        if (alarmId == this.ALARM_ID_E01) { // NOSONAR
            return this.getE01ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E02) { // NOSONAR
            return this.getE02ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E03) { // NOSONAR
            return this.getE03ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E06) { // NOSONAR
            return this.getE06ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E07) { // NOSONAR
            return this.getE07ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E09) { // NOSONAR
            return this.getE09ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E10) { // NOSONAR
            return this.getE10ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E11) { // NOSONAR
            return this.getE11ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E12) { // NOSONAR
            return this.getE12ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E13) { // NOSONAR
            return this.getE13ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E14) { // NOSONAR
            return this.getE14ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E16) { // NOSONAR
            return this.getE16ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E17) { // NOSONAR
            return this.getE17ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E18) { // NOSONAR
            return this.getE18ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E19) { // NOSONAR
            return this.getE19ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E21) { // NOSONAR
            return this.getE21ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E23) { // NOSONAR
            return this.getE23ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E24) { // NOSONAR
            return this.getE24ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E25) { // NOSONAR
            return this.getE25ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E26) { // NOSONAR
            return this.getE26ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_E27) { // NOSONAR
            return this.getE27ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_F01) { // NOSONAR
            return this.getF01ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_F02) { // NOSONAR
            return this.getF02ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_F04) { // NOSONAR
            return this.getF04ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_F05) { // NOSONAR
            return this.getF05ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_F06) { // NOSONAR
            return this.getF06ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_F09) { // NOSONAR
            return this.getF09ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_G01) { // NOSONAR
            return this.getG01ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_G02) { // NOSONAR
            return this.getG02ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_G06) { // NOSONAR
            return this.getG06ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_G07) { // NOSONAR
            return this.getG07ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H04) { // NOSONAR
            return this.getH04ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H05) { // NOSONAR
            return this.getH05ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H06) { // NOSONAR
            return this.getH06ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H07) { // NOSONAR
            return this.getH07ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H09) { // NOSONAR
            return this.getH09ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H12) { // NOSONAR
            return this.getH12ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H13) { // NOSONAR
            return this.getH13ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H14) { // NOSONAR
            return this.getH14ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H15) { // NOSONAR
            return this.getH15ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H17) { // NOSONAR
            return this.getH17ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H20) { // NOSONAR
            return this.getH20ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H21) { // NOSONAR
            return this.getH21ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H28) { // NOSONAR
            return this.getH28ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H29) { // NOSONAR
            return this.getH29ExportData(rowData, alarmId, alarm);
        }
        else if (alarmId == this.ALARM_ID_H30) { // NOSONAR
            return this.getH30ExportData(rowData, alarmId, alarm);
        }
        else {
            return this.getE01ExportData(rowData, alarmId, alarm);
        }
    }

    public getE01ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getE02ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                overtime: element.overtime
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getE03ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                overtime: element.overtime
            };
            exportData.push(obj);
        });
        console.info(exportData+'32')
        return exportData;
    }

    public getE06ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                overtime: element.overtime
            };
            exportData.push(obj);
        });
        console.info(exportData+'21')
        return exportData;
    }

    public getE07ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getE09ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                logisticsPoint: element.logisticsPoint
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getE10ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier
            };
            exportData.push(obj);
        });
        console.info('we')
        return exportData;
    }

    public getE11ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier
            };
            exportData.push(obj);
        });
        console.info('dd')
        return exportData;
    }

    public getE12ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info('some')
        return exportData;
    }

    public getE13ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info(exportData,'ww')
        return exportData;
    }

    public getE14ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                overtime: element.overtime
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getE16ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                supplier: element.supplier,
                puRoute: element.puRoute,
                arrival: this.getDateTime(element.arrival),
                departure: this.getDateTime(element.departure),
                overlapPuroute: element.overlapPuroute,
                overlapArrival: this.getDateTime(element.overlapArrival),
                overlapDeparture: this.getDateTime(element.overlapDeparture)
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getE17ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                logisticsPoint: element.logisticsPoint,
                shortage: element.shortage
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getE18ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                overtime: element.overtime
            };
            exportData.push(obj);
        });
        console.info(exportData,'ss')
        return exportData;
    }

    public getE19ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getE21ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info(exportData,'11')
        return exportData;
    }

    public getE23ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info(exportData,'33')
        return exportData;
    }

    public getE24ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info(exportData,'56')
        return exportData;
    }

    public getE25ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info(exportData,'34')
        return exportData;
    }

    public getE26ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info(exportData,'12')
        return exportData;
    }

    public getE27ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                logisticsPoint: element.logisticsPoint,
                shortage: element.shortage
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getF01ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                logisticsPoint: element.logisticsPoint,
                logisticsPointDate: this.getDate(element.logisticsPointDate)
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getF02ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                logisticsPoint: element.logisticsPoint,
                logisticsPointDate: this.getDate(element.logisticsPointDate)
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getF04ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                plant: element.plant,
                dock: element.dock
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getF05ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                plant: element.plant,
                dock: element.dock
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getF06ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                plant: element.plant,
                dock: element.dock
            };
            exportData.push(obj);
        });
        console.info(exportData,'12')
        return exportData;
    }

    public getF09ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info(exportData,'122')
        return exportData;
    }

    public getF11ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                logisticsPoint: element.logisticsPoint
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getG01ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                resourceType: element.resourceType,
                combinationNumber: element.combinationNumber
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getG02ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                resourceType: element.resourceType,
                combinationNumber: element.combinationNumber
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getG06ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                resourceType: element.resourceType,
                combinationNumber: element.combinationNumber,
                overtime: element.overtime
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getG07ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                combinationNumber: element.combinationNumber,
                overtime: element.overtime,
                logisticsPoint: element.logisticsPoint
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getH04ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock,
                orderDate: this.getDate(element.orderDate),
                orderSequence: element.orderSequence
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getH05ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getH06ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                logisticsPoint: element.logisticsPoint,
                routeListNumberItemCode: element.routeListNumberItemCode
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getH07ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock,
                routeListNumberItemCode: element.routeListNumberItemCode
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getH09ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock,
                orders: element.orders
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getH12ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock,
                orderDate: this.getDate(element.orderDate)
            };
            exportData.push(obj);
        });
        return exportData;
    }

    public getH13ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate)
            };
            exportData.push(obj);
        });
        console.info(exportData+'22')
        return exportData;
    }

    public getH14ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getH15ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock
            };
            exportData.push(obj);
        });
        console.info(exportData+'result')
        return exportData;
    }

    public getH17ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock,
                routeListNumberItemCode: element.routeListNumberItemCode
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getH20ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock,
                orderDate: this.getDate(element.orderDate)
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getH21ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock,
                orderDate: this.getDate(element.orderDate),
                orderSequence: element.orderSequence
            };
            exportData.push(obj);
        });
        console.info(exportData)
        return exportData;
    }

    public getH28ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock
            };
            exportData.push(obj);
        });
        console.info(exportData+'result1')
        return exportData;
    }

    public getH29ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock
            };
            exportData.push(obj);
        });
        console.info(exportData+'result4')
        return exportData;
    }

    public getH30ExportData(rowData: any, alarmId: string, alarm: string) {
        const exportData: any = [];
        rowData.forEach(element => {
            const obj = {
                id: alarmId,
                alarm: alarm,
                domicile: element.domicile,
                puRoute: element.puRoute,
                routeDate: this.getDate(element.routeDate),
                supplier: element.supplier,
                plant: element.plant,
                dock: element.dock,
                orderDate: this.getDate(element.orderDate)
            };
            exportData.push(obj);
        });
        console.info(exportData+'result3')
        return exportData;
    }

    public getE01ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date']; // NOSONAR
    }

    public getE02ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Overtime'];
    }

    public getE03ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Overtime'];
    }

    public getE06ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Overtime'];
    }

    public getE07ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier'];
    }

    public getE09ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Logistics Point']; // NOSONAR
    }

    public getE10ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier'];
    }

    public getE11ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier'];
    }

    public getE12ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getE13ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getE14ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Overtime'];
    }

    public getE16ExportHeader() {
        return ['ID', 'Alarm', 'Supplier', 'Route', 'Arrival', 'Departure', 'Overlap Route', 'Overlap Arrival', 'Overlap Departure'];
    }

    public getE17ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Logistics Point', 'Short Time']; // NOSONAR
    }

    public getE18ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'overtime'];
    }

    public getE19ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getE21ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getE23ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getE24ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getE25ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getE26ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getE27ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Logistics Point', 'Short Time']; // NOSONAR
    }

    public getF01ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Logistics Point', 'Pickup Date']; // NOSONAR
    }

    public getF02ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Logistics Point', 'Pickup Date'];// NOSONAR
    }

    public getF04ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Plant', 'Dock'];
    }

    public getF05ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Plant', 'Dock'];
    }

    public getF06ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Plant', 'Dock'];
    }

    public getF09ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getF11ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Logistics Point']; // NOSONAR
    }

    public getG01ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Resource Type', 'Combination No']; // NOSONAR
    }

    public getG02ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Resource Type', 'Combination No']; // NOSONAR
    }

    public getG06ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Resource Type', 'Combination No', 'Overtime']; // NOSONAR
    }

    public getG07ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Combination No', 'Overtime', 'Logistics Point'];
    }

    public getH04ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock', 'Order Date', 'Order Number']; // NOSONAR
    }

    public getH05ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock'];
    }

    public getH06ExportHeader() { // NOSONAR
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Logistics Point', 'Order Type']; // NOSONAR
    }

    public getH07ExportHeader() {
        return ['Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock', 'Order Type'];
    }

    public getH09ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock', 'SL'];
    }

    public getH12ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock', 'Order Date']; // NOSONAR
    }

    public getH13ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date'];
    }

    public getH14ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock'];
    }

    public getH15ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock'];
    }

    public getH17ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock', 'Order Type'];
    }

    public getH20ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock', 'Order Date']; // NOSONAR
    }

    public getH21ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock', 'Order Date', 'Order Number']; // NOSONAR
    }

    public getH28ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock'];
    }

    public getH29ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock'];
    }

    public getH30ExportHeader() {
        return ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Supplier', 'Plant', 'Dock', 'Order Date']; // NOSONAR
    }

    getDate(dt: any) {
        return this.pipe.transform(dt, 'MM/dd/yyyy');
    }

    getDateTime(dt: any) {
        return this.pipe.transform(dt, 'MM/dd/yyyy HH:mm');
    }

}
